import * as Yup from 'yup';

const facilityValidation = (t: (key: string) => string) => ({
  create: Yup.object().shape({
    status: Yup.string().required(t('checkReportDialog.statusRequired')),
    check_date: Yup.string().required(t('checkReportDialog.checkDateRequired')),
    check_status: Yup.string().required(t('checkReportDialog.checkStatusRequired')),
  }),
  createFacility: Yup.object().shape({
    location_name: Yup.string().required(t('editFacilityDialog.locationNameRequired')),
    manager_name: Yup.string().required(t('editFacilityDialog.managerNameRequired')),
    manager_phone: Yup.string().required(t('editFacilityDialog.managerPhoneRequired')),
    priority_level: Yup.string().required(t('editFacilityDialog.priorityLevelRequired')),
    type_business: Yup.string().required(t('editFacilityDialog.typeBusinessRequired')),
    manager_unit: Yup.string().required(t('editFacilityDialog.managerUnitRequired')),
    province_code: Yup.string().required(t('editFacilityDialog.provinceRequired')),
    ward_code: Yup.string().required(t('editFacilityDialog.wardRequired')),
    address: Yup.string().required(t('editFacilityDialog.addressRequired')),
    location: Yup.mixed().test(
      'has-location',
      t('editFacilityDialog.locationRequired'),
      (value: any) => !!(value && value.lat && value.lng)
    ),
  }),
  addDevice: Yup.object().shape({
    device_code: Yup.string().required(t('editEquipmentDialog.deviceCodeRequired')),
  }),
});

export default facilityValidation;
